import { render } from "./MarketPerformanceChart.vue?vue&type=template&id=c5a80efc&ts=true"
import script from "./MarketPerformanceChart.vue?vue&type=script&lang=ts"
export * from "./MarketPerformanceChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__